import type { Quote } from "./types";
import { createQuoteStory } from "./types";

export const istiqamahFussilat30: Quote = {
  id: "istiqamah-fussilat-30",
  name: "Istiqamah Setelah Ramadhan",
  emoji: "🛤️",
  category: "Ibadah & Ramadhan",
  description:
    "Ramadhan berakhir, tapi perjalanan belum selesai. Allah menjanjikan **malaikat turun** bagi yang istiqamah, para salaf berdoa **6 bulan** agar amalnya diterima, dan Rasulullah ﷺ mengajarkan **puasa 6 hari Syawal** sebagai jembatan menuju pahala setahun.",
  detail:
    "Kumpulan dalil tentang menjaga istiqamah setelah Ramadhan. Dimulai dari QS. Fussilat: 30 tentang janji Allah bagi yang istiqamah, dilanjutkan perkataan Mu'alla ibn al-Fadl tentang 6 bulan berdoa agar amal diterima, hadits puasa 6 hari Syawal (HR. Muslim 1164), dan hikmah salaf tentang **tanda diterimanya amal adalah amal shalih setelahnya**. Semua mengarah pada satu pesan: Ramadhan adalah awal, bukan akhir.",
  tldr: "Ramadhan selesai, tapi istiqamah baru dimulai — jaga amal, puasa Syawal, dan berdoa agar diterima.",
  story: createQuoteStory("Istiqamah Setelah Ramadhan", "🛤️", [
    { hook: {
      title: "Ramadhan sudah selesai. Terus sekarang gimana?",
      body: "Sebulan rajin ibadah, bangun sahur, tarawih tiap malam. Tapi sekarang Ramadhan pergi. **Apa yang tersisa?**",
    } },
    { source: {
      arabic:
        "إِنَّ الَّذِينَ قَالُوا رَبُّنَا اللَّهُ ثُمَّ اسْتَقَامُوا تَتَنَزَّلُ عَلَيْهِمُ الْمَلَائِكَةُ أَلَّا تَخَافُوا وَلَا تَحْزَنُوا وَأَبْشِرُوا بِالْجَنَّةِ الَّتِي كُنتُمْ تُوعَدُونَ",
      body: "Sesungguhnya orang-orang yang berkata, \"Tuhan kami adalah Allah,\" kemudian mereka **tetap istiqamah**, maka malaikat-malaikat akan turun kepada mereka (dengan berkata), \"**Jangan takut dan jangan bersedih**; dan bergembiralah dengan surga yang telah dijanjikan kepadamu.\"",
      title: "QS. Fussilat: 30",
    } },
    { source: {
      arabic:
        "مَنْ صَامَ رَمَضَانَ ثُمَّ أَتْبَعَهُ سِتًّا مِنْ شَوَّالٍ كَانَ كَصِيَامِ الدَّهْرِ",
      body: "Barangsiapa berpuasa Ramadhan, lalu mengiringinya dengan **6 hari** di bulan Syawal, maka seakan-akan ia berpuasa **setahun penuh**.",
      title: "HR. Muslim no. 1164",
    } },
    { reveal: {
      body: "Yang Allah puji bukan yang paling semangat di Ramadhan — tapi yang **masih berjalan setelahnya**. Kata kuncinya: **tsumma** — kemudian. Istiqamah itu soal **apa yang kamu lakukan setelah Ramadhan pergi**.",
    } },
    { insight: {
      title: "\"Alhamdulillah, Ramadhan selesai.\" — kita.",
      body: "\"Ya Allah, **terima amal kami**.\" — para salaf.\n\nMereka berdoa 6 bulan penuh setelah Ramadhan. Karena mereka paham: beramal itu mudah, **yang sulit adalah memastikan amal itu diterima**.",
    } },
    { insight: {
      title: "\"Tanda diterimanya kebaikan adalah kebaikan setelahnya.\" — hikmah salaf",
      body: "Puasa Syawal adalah salah satu buktinya — **berpuasa saat orang lain sudah berhenti**. Pertanyaannya: setelah Ramadhan, kamu masih berusaha menjaga amalmu — **atau sudah berhenti?**",
    } },
    { engagement: {
      title: "Ramadhan selesai. Perjalananmu belum.",
      body: "Boleh pelan — tapi jangan sampai berhenti lalu **lupa untuk mulai lagi**.",
    } },
  ]),
  related: ["puasa-syawal-muslim-1164", "sabar-baqarah-153"],
};
